import React, { useContext, useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  makeStyles,
  withStyles,
  InputAdornment,
} from "@material-ui/core";

import StepConnector from "@material-ui/core/StepConnector";

import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import DonutSmallIcon from "@material-ui/icons/DonutSmall";

import clsx from "clsx";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal } from "../../../financeiro/nfe/styles/Emissao";
import Tree from "../../../../components/tree/Tree";
import TextField from "../../../../components/basics/TextFieldErp";

import { ClassificacaoServicoContext } from "../contexts/ClassificacaoServicoContext";

import useClassificacaoServicoController from "../controllers/ClassificacaoServicoController";

const steps = ["Seleção de Categoria", "Porcentagem"];

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%, rgb(188, 220, 207) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%, rgb(188, 220, 207) 100%)",
  },
});

const ColorlibStepIcon = (props) => {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <BusinessCenterIcon />,
    2: <DonutSmallIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
};

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const ModalClassifCentroNegocio = ({ open, setOpen, index }) => {
  const {
    costCenters,
    percentage,
    setPercentage,
    activeStep,
    setActiveStep,
    setSelectedCostCenter,
    selectedCostCenter,
    ratioLimitPercentage,
  } = useContext(ClassificacaoServicoContext);

  const { selectCenterCostAction, confirmCenterCost, handleMaxPercentage } =
    useClassificacaoServicoController();

  useEffect(() => {
    setPercentage(ratioLimitPercentage);
  }, [ratioLimitPercentage, setPercentage]);

  const handleClose = () => {
    setActiveStep(0);
    setPercentage("0,00");
    setSelectedCostCenter(null);
    setOpen(false);
  };

  const getStepContent = (step) => {
    const contents = {
      0: (
        <>
          {costCenters.length && (
            <Tree branches={costCenters} action={selectCenterCostAction} />
          )}
        </>
      ),
      1: (
        <>
          <Grid item xs={12}>
            <TextField
              label="Categoria"
              value={selectedCostCenter?.descricao}
              variant="filled"
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Porcentagem"
              value={percentage}
              setValue={(e) => handleMaxPercentage(e, setPercentage)}
              mask="decimal"
              endAdornment={<InputAdornment position="end">%</InputAdornment>}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Porcentagem restante"
              size="small"
              value={ratioLimitPercentage}
              endAdornment={<InputAdornment position="end">%</InputAdornment>}
              variant="filled"
              disabled
            />
          </Grid>
        </>
      ),
    };

    return contents[step];
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-forma-pagto"
      >
        <HeaderModal>
          <DialogTitle id="dialog-forma-pagto">
            <Chip label="CATEGORIAS" bgcolor="primary" textcolor="white" />
          </DialogTitle>
        </HeaderModal>
        <DialogContent>
          <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<ColorlibConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          <Grid container spacing={2} justifyContent="center">
            {getStepContent(activeStep)}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn
            bgcolor="tertiary"
            hovercolor="red"
            onClick={handleClose}
            label="cancelar"
          />
          <Btn
            bgcolor="primary"
            hovercolor="orange"
            label="Confirmar"
            onClick={() => confirmCenterCost(setOpen)}
            disabled={activeStep === 0}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalClassifCentroNegocio;
